import React, { useState, useRef } from "react";
import "./Tooltip.scss";
import PropTypes from "prop-types";

Tooltip.propTypes = {
  notes: PropTypes.string,
  flightNumber: PropTypes.string,
  apiFailure: PropTypes.object,
};
export default function Tooltip({
  imgSource,
  imgAlt,
  flightNumber,
  notes,
  averageFare,
  className,
  adminNotes,
  apiFailure,
}) {
  const anchorRef = useRef(null);
  const [failurePos, setFailurePos] = useState(null);

  // The API-failure tooltip uses fixed positioning so it is never clipped by
  // the scroll container (`.table-responsive` has overflow-x:auto, which also
  // clips vertically on the first/last rows). Position is computed on hover.
  const showFailureTip = () => {
    if (!apiFailure || !anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    setFailurePos({
      top: rect.top + rect.height / 2,
      left: rect.left,
    });
  };
  const hideFailureTip = () => setFailurePos(null);

  if (apiFailure) {
    return (
      <span
        ref={anchorRef}
        className="api-failure-anchor"
        onMouseEnter={showFailureTip}
        onMouseLeave={hideFailureTip}
      >
        <img className={className ? "" : "ml-5"} src={imgSource} alt={imgAlt} />
        {failurePos ? (
          <div
            className="api-failure-fixed-tip"
            style={{ top: failurePos.top, left: failurePos.left }}
          >
            <div>⚠️ {apiFailure.apiFailureCount} API failure(s).</div>
            {apiFailure.lastApiFailure ? (
              <>
                <div>
                  Last:{" "}
                  <strong>{apiFailure.lastApiFailure.action || "-"}</strong> —{" "}
                  {apiFailure.lastApiFailure.message || "-"}
                </div>
                <div>
                  ({apiFailure.lastApiFailure.service || "-"} ·{" "}
                  {apiFailure.lastApiFailure.at || "-"})
                </div>
              </>
            ) : null}
          </div>
        ) : null}
      </span>
    );
  }

  return (
    <div className={`tooltip${className ? "" : " ml-5"}`}>
      <img className={className ? "" : "ml-5"} src={imgSource} alt={imgAlt} />
      <div className="tooltiptext">
        {flightNumber ? <div>Flight no: {flightNumber}</div> : ""}
        {notes ? <div>Notes: {notes}</div> : ""}
        {averageFare ? <div>The average fare is Rs {averageFare}</div> : ""}
        {adminNotes ? <div>{adminNotes}</div> : ""}
      </div>
    </div>
  );
}
